export default {
  getToken: state =>  {
    return state.token
  },
  getActiveUser: state => {
    return state.activeUser
  },
  getNotifSetting: state => {
    return state.notifSetting
  }
}